export class JobCountsModel
{
    Enqueued:number
    Scheduled:number
    Processing:number
    Succeeded:number
    Failed:number
    Deleted:number
      
}
     